module.exports = __webpack_public_path__ + "static/media/Fencer.e136559b.jpg";